import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

import styles from "./Stack.module.scss";

const getSpacingClassForSpacingUnit = (spacingUnit) => {
  switch (spacingUnit) {
    case "extra-small":
      return styles.stackSpacingExtraSmall;
    case "small":
      return styles.stackSpacingSmall;
    case "large":
      return styles.stackSpacingLarge;
    case "default":
      return styles.stackSpacingDefault;
  }
};

const Stack = ({
  as = "div",
  children,
  className,
  horizontal,
  vertical,
  spacing = "default",
  ...rest
}) => {
  const classes = classNames(
    styles.stack,
    {
      [styles.stackHorizontal]: horizontal,
      [styles.stackVertical]: vertical,
    },
    getSpacingClassForSpacingUnit(spacing),
    className
  );

  return React.createElement(as, {
    className: classes,
    children,
    ...rest,
  });
};

Stack.propTypes = {
  className: PropTypes.string,
  horizontal: PropTypes.bool,
  vertical: PropTypes.bool,
  spacing: PropTypes.oneOf(["extra-small", "small", "default", "large"]),
};

export default Stack;
